import React, { useCallback, useRef } from 'react';

const RotateHandle = ({ onRotate }) => {
  const handleRef = useRef(null);

  const handleMouseDown = useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();

      const parent = handleRef.current.parentElement;

      const onMouseMove = (moveEvent) => {
        const rect = parent.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        const dx = moveEvent.clientX - centerX;
        const dy = moveEvent.clientY - centerY;

        let angle = (Math.atan2(dy, dx) * 180) / Math.PI + 90;
        angle = Math.round(angle);
        if (angle < 0) angle += 360;

        onRotate(angle);
      };

      const onMouseUp = () => {
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
      };

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    },
    [onRotate]
  );

  return (
    <div
      ref={handleRef}
      className="rotateHandle"
      onMouseDown={handleMouseDown}
      title="Drag to rotate"
    >
      &#8635;
    </div>
  );
};

export default RotateHandle;
